import { axiosInstance } from '../../../api/axiosConfig';
import type {
  ExternalUserDashboardData,
  ExternalDashboardFilters,
  UpsellDashboardAvailability,
  UpsellGarantDashboard,
} from '../types/dashboard.types';

export const externalUserDashboardApi = {
  getDashboard: async (
    userId: string,
    filters?: ExternalDashboardFilters,
    warrantyName?: string,
  ): Promise<ExternalUserDashboardData> => {
    const params = new URLSearchParams();

    if (filters?.period) {
      params.append('period', filters.period);
    }

    if (filters?.startDate) {
      params.append('startDate', filters.startDate);
    }

    if (filters?.endDate) {
      params.append('endDate', filters.endDate);
    }

    if (filters?.storeId) {
      params.append('storeId', filters.storeId);
    }

    if (filters?.filterUserId) {
      params.append('filterUserId', filters.filterUserId);
    }

    if (warrantyName) {
      params.append('warrantyName', warrantyName);
    }

    const queryString = params.toString();
    const url = `/pro-v2/external-users/${userId}/dashboard${queryString ? `?${queryString}` : ''}`;

    const { data } = await axiosInstance.get<ExternalUserDashboardData>(url);
    return data;
  },

  getDashboardBySociety: async (
    societyId: string,
    filters?: ExternalDashboardFilters,
    warrantyName?: string,
  ): Promise<ExternalUserDashboardData> => {
    const params = new URLSearchParams();

    if (filters?.period) params.append('period', filters.period);
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);
    if (filters?.storeId) params.append('storeId', filters.storeId);
    if (filters?.filterUserId) params.append('filterUserId', filters.filterUserId);
    if (warrantyName) params.append('warrantyName', warrantyName);

    const queryString = params.toString();
    const url = `/pro-v2/societies/${societyId}/dashboard${queryString ? `?${queryString}` : ''}`;

    const { data } = await axiosInstance.get<ExternalUserDashboardData>(url);
    return data;
  },

  /** Le garant de l'utilisateur connecté a-t-il un programme upsell ? */
  getUpsellAvailability: async (): Promise<UpsellDashboardAvailability> => {
    const { data } = await axiosInstance.get<UpsellDashboardAvailability>('/pro-v2/upsell-dashboard/availability');
    return data;
  },

  /** Chiffres du programme upsell du garant (montants en centimes). Sans borne : tout l'historique. */
  getUpsellDashboard: async (period: { from?: string; to?: string }): Promise<UpsellGarantDashboard> => {
    const params: Record<string, string> = {};
    if (period.from) params.from = period.from;
    if (period.to) params.to = period.to;

    const { data } = await axiosInstance.get<UpsellGarantDashboard>('/pro-v2/upsell-dashboard', { params });
    return data;
  },
};
